import axios from "axios";
import config from "../../../config/config";

const REGISTER_EMPLOYER = config.baseUrl + "employment";

export function sendRezomeInfo(data) {
    return axios.post(REGISTER_EMPLOYER, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}